import React, {useState} from "react";
import {UserContext} from "../contexts/UserContext";
import MultiFactorRegistration from "../login/MultiFactorRegistration";
import MultiFactorAuthentication from "../login/MultifactorAuthentication";
import {Redirect, useLocation} from "react-router-dom";
import MFAService from "../../services/MFAService";

const MFAVerification = () => {
  const { user } = React.useContext(UserContext)
  const [mfaRegistrationModal, setMfaRegistrationModal] = useState(false);
  const [mfaVerificationModal, setMfaVerificationModal] = useState(false);
  const [mfaRegistrationSubmitLoading, setMfaRegistrationSubmitLoading] = useState(false);
  const [mfaVerificationSubmitLoading, setMfaVerificationSubmitLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState();
  const prevLocation = useLocation();

  const getRedirectPath = (user) => {
    if (prevLocation.state) {
      return prevLocation.state.from
    } else {
      if (user.hasOwnProperty("loginPath") && user.loginPath !== null) {
        return user.loginPath
      }
    }
  }

  const toggleMfaRegistrationModal = () => {
    setMfaRegistrationModal(!mfaRegistrationModal)
  }

  const toggleMfaVerificationModal = () => {
    setMfaVerificationModal(!mfaVerificationModal)
  }

  const onSubmitMFARegistration = (data) => {
    setMfaRegistrationSubmitLoading(true)
    data.userEmail = user.email
    MFAService.enable(data)
      .then(response => {
        if (response.status === 204) {
          let route = getRedirectPath(user)
          if (prevLocation.state && prevLocation.state.from) {
            route = prevLocation.state.from
          }
          window.location.href = route
        }
      })
      .catch(err => {
        console.log(err.response.data)
        setErrorMessage(err.response.data.errorMessage)
      })
      .finally(() => {
        setMfaRegistrationSubmitLoading(false)
      })
  }

  const onSubmitMFA = (data) => {
    setMfaVerificationSubmitLoading(true)
    data.userEmail = user.email
    MFAService.validate(data)
      .then(() => {
        let route = getRedirectPath(user)
        if (prevLocation.state && prevLocation.state.from) {
          route = prevLocation.state.from
        }
        window.location.href = route
      })
      .catch(err => {
        console.log(err)
        setErrorMessage(err.response.data.errorMessage)
      })
      .finally(() => {
        setMfaVerificationSubmitLoading(false)
      })
  }

  return (
    <div className="atlas-layout-mfa">
      <UserContext.Consumer>
        {({user}) => {
          if (user && user.authenticated) {
            if (!user.mfaEnabled) {
              return <MultiFactorRegistration
                modal={true}
                toggleModal={toggleMfaRegistrationModal}
                email={user.email}
                onSubmit={onSubmitMFARegistration}
                errorMessage={errorMessage}
                submitLoading={mfaRegistrationSubmitLoading}/>
            } else if (!user.mfaVerified) {
              return <MultiFactorAuthentication
                errorMessage={errorMessage}
                modal={true}
                toggleModal={toggleMfaVerificationModal}
                onSubmitMfaCode={onSubmitMFA}
                verificationLoading={mfaVerificationSubmitLoading}/>
            } else if (user.mfaEnabled && user.mfaVerified) {
              return (
                <Redirect from="/" to={getRedirectPath(user)}/>
              )
            }
          }
        }}
      </UserContext.Consumer>
    </div>
  );
};

export default MFAVerification;
